import { Box } from '@material-ui/core';
import * as React from 'react';
import styled from 'styled-components';

const ContainedBrandedImage = styled.img`
  max-width: 100%;
  max-height: 200px;
`;

interface Props {
    imageSrc: string;
    children?: React.ReactNode;
    offset?: boolean;
}

export const BannerHeader = (
    {
        imageSrc,
        children,
        offset
    }: Props
) => {
    if (offset) {
        return (
            <Box maxWidth={800}
                 width='100%'
                 display={'flex'}
                 flex={'0 0 auto'}
                 flexDirection={'row'}
                 justifyContent='center'
                 position='relative'
                 margin='0 auto'>
                <div style={{ position: 'relative' }}>
                    <ContainedBrandedImage src={imageSrc} />
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0
                    }}>{children}</div>
                </div>
            </Box>
        );
    }

    return (
        <Box maxWidth={800}
             width='100%'
             display={'flex'}
             flex={'0 0 auto'}
             flexDirection={'row'}
             justifyContent='center'
             position='relative'
             margin='0 auto'>
            <ContainedBrandedImage src={imageSrc} />
            <div style={{
                position: 'absolute',
                top: '50%',
                right: 0,
                transform: 'translate(-50%, -50%)'
            }}>{children}</div>
        </Box>
    );
};



// WEBPACK FOOTER //
// ./src/components/branding/banner-header.tsx